import { render } from "./ApiError.vue?vue&type=template&id=f730efb2&scoped=true"
const script = {}

import "./ApiError.vue?vue&type=style&index=0&id=f730efb2&lang=scss&scoped=true"

import exportComponent from "../../../../MemberPortal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f730efb2"]])

export default __exports__